import { doc, onSnapshot } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import Message from "./Message";
import { useSelector } from "react-redux";
import { SelectChatUser } from "../../../../store/chatUserSlice";
import { SelectUser } from "../../../../store/usersSlice";
import { db } from "../../../../firebase";

const Messages = ({users}) => {
  const [messages, setMessages] = useState([]);
  const data  = useSelector(SelectChatUser);
  const currentUser  = useSelector(SelectUser);

  useEffect(() => {
    const unSub = onSnapshot(doc(db, "companies", currentUser?.companyName, "chats", data?.chatId), (doc) => {
      doc.exists() && setMessages(doc.data().messages);
    });

    return () => {
      unSub();
    };
  }, [data.chatId]);

  console.log(messages)

  return (
    <div className="chat-content" style={{
        borderRight: "1px solid silver",
      }}>
      { data?.chatId && messages.map((m) => (
        <Message message={m} key={m.id} users={users}/>
      ))}
    </div>
  );
};

export default Messages;
